// Daily prompts - 50 calm, supportive messages
export const dailyPrompts = [
  "Today, just breathe.",
  "Rebuilding happens one day at a time.",
  "A small step is still a step.",
  "You don't need to be perfect. You just need to show up.",
  "Consistency over intensity.",
  "Showing up is the win.",
  "Some days are for resting. That's still part of the rebuild.",
  "You are not your setbacks.",
  "This is your rhythm. Trust it.",
  "One day at a time.",
  "Progress, not perfection.",
  "You're doing the work.",
  "Be kind to yourself today.",
  "Today is a fresh start.",
  "Small moments add up.",
  "You've done hard things before.",
  "Rest is part of the rebuild.",
  "Just for today, show up.",
  "You're allowed to have off days.",
  "This is your practice. It doesn't have to be perfect.",
  "Breathe. You've got this.",
  "Every day you show up, you win.",
  "Your only job today is to be present.",
  "You are building something steady.",
  "Trust the rhythm.",
  "Some days are for action. Some are for rest. Both count.",
  "You're not behind. You're exactly where you need to be.",
  "Start where you are. Use what you have.",
  "A pause is not a stop.",
  "You're still in the game.",
  "This is how you rebuild: one day at a time.",
  "Give yourself credit for showing up.",
  "You're allowed to scale down.",
  "The easy activity is still a win.",
  "You're not starting over. You're continuing.",
  "Even a small step moves you forward.",
  "You're building trust with yourself.",
  "This is your system. It's designed to hold you.",
  "You don't need to earn your rest.",
  "Today, just do what you can.",
  "You're doing better than you think.",
  "The rhythm matters more than the intensity.",
  "You're allowed to have a low-energy day.",
  "You're still here. That's the foundation.",
  "Every checkmark is evidence.",
  "You're not failing. You're rebuilding.",
  "This is a long game. You're playing it well.",
  "Your only goal today: show up in some form.",
  "Tomorrow is a fresh day. So is today.",
  "You showed up. That matters.",
  "Wherever there is darkness there is Light.",
  "Own it!"
];

// Completion messages for when at least one activity was marked
export const activityCompletedMessages = [
  "Well done, {name}. You showed up today.",
  "Great work, {name}. Every step counts.",
  "You did it, {name}. That's what matters.",
  "Proud of you, {name}. Keep building.",
  "Nice one, {name}. Consistency in action.",
  "You showed up, {name}. That's the win.",
  "Another day done, {name}. Well played.",
  "You're building something real, {name}.",
  "That's progress, {name}. Steady and sure.",
  "Well done, {name}. One day at a time.",
  "You made it happen today, {name}.",
  "Evidence of effort, {name}. Well done.",
  "Today counts, {name}. You showed up.",
  "You're on the path, {name}. Keep going.",
  "Logged and done, {name}. Nice work.",
  "Another brick laid, {name}. Building well.",
  "You took action today, {name}. Respect.",
  "Small wins stack up, {name}. This is one.",
  "You're doing the work, {name}. It shows.",
  "Consistency achieved, {name}. Well done.",
  "You moved today, {name}. That matters.",
  "Progress logged, {name}. Keep it up.",
  "You're in the game, {name}. Stay there.",
  "Today's effort recorded, {name}. Proud of you.",
  "You didn't skip today, {name}. That's huge.",
  "Action taken, {name}. Well done.",
  "You're showing up for yourself, {name}.",
  "Today's a win, {name}. Take it.",
  "You're building the habit, {name}.",
  "Effort made, {name}. That's what counts.",
  "You're doing this, {name}. Keep going.",
  "Another day, another step, {name}.",
  "You committed today, {name}. Respect.",
  "This is how it's done, {name}. Daily.",
  "You're proving something to yourself, {name}.",
  "Logged and noted, {name}. Great work.",
  "You showed up when it mattered, {name}.",
  "Today's effort is tomorrow's foundation, {name}.",
  "You're in motion, {name}. Stay there.",
  "Well logged, {name}. Well done.",
  "You're keeping the streak alive, {name}.",
  "Progress is progress, {name}. This counts.",
  "You did the thing today, {name}.",
  "Today's done, {name}. Rest easy.",
  "You're building trust with yourself, {name}.",
  "Action over excuses, {name}. Nice work.",
  "You chose to show up, {name}. That's powerful.",
  "Today's entry saved, {name}. Great job.",
  "You're in it, {name}. Keep building.",
  "Evidence of effort, {name}. Keep going."
];

// Completion messages for when only reflections/notes were filled
export const reflectionOnlyMessages = [
  "You checked in today, {name}. That still counts.",
  "Reflection is part of the rebuild, {name}.",
  "You showed up in thought, {name}. Valid.",
  "Checking in matters, {name}. Well done.",
  "Today's reflection saved, {name}.",
  "You took time to reflect, {name}. That's real work.",
  "Inner work counts too, {name}.",
  "You connected with yourself today, {name}.",
  "Reflection logged, {name}. Keep going.",
  "You paused and thought, {name}. That's progress.",
  "Self-reflection is a form of showing up, {name}.",
  "You checked in, {name}. That matters.",
  "Today's thoughts saved, {name}.",
  "You gave yourself attention, {name}.",
  "Mental check-in complete, {name}.",
  "You took the time, {name}. Well done.",
  "Reflection is action, {name}.",
  "You showed up mentally, {name}. Counts.",
  "Today's introspection logged, {name}.",
  "You connected with the process, {name}.",
  "Checking in is a win, {name}.",
  "You reflected today, {name}. Keep it up.",
  "Inner work is real work, {name}.",
  "You gave today some thought, {name}.",
  "Reflection saved, {name}. Well done.",
  "You engaged with yourself, {name}.",
  "Today's thoughts matter, {name}.",
  "You took a moment, {name}. That counts.",
  "Mindful check-in complete, {name}.",
  "You showed up in your own way, {name}.",
  "Self-awareness is progress, {name}.",
  "You logged your thoughts, {name}.",
  "Today's reflection is tomorrow's clarity, {name}.",
  "You gave yourself space, {name}.",
  "Thoughts captured, {name}. Keep building.",
  "You checked in with yourself, {name}.",
  "Today's pause was productive, {name}.",
  "You reflected, {name}. That's enough.",
  "Inner check-in saved, {name}.",
  "You connected today, {name}. Well done.",
  "Reflection is part of the journey, {name}.",
  "You gave today meaning, {name}.",
  "Thoughts logged, {name}. Keep going.",
  "You engaged with the day, {name}.",
  "Today's reflection complete, {name}.",
  "You showed up thoughtfully, {name}.",
  "Inner work logged, {name}.",
  "You took time for yourself, {name}.",
  "Reflection is rebuilding, {name}.",
  "You checked in, {name}. Tomorrow's fresh."
];

// Completion messages for when nothing was filled
export const emptyLogMessages = [
  "Saved. Tomorrow is a fresh day.",
  "Entry saved. Rest up.",
  "Logged. Today's done.",
  "Saved. No pressure.",
  "Entry noted. Tomorrow awaits.",
  "Saved. Take it easy.",
  "Logged for today. Rest well.",
  "Entry saved. New day tomorrow.",
  "Saved. That's okay.",
  "Today's entry saved.",
  "Logged. Tomorrow's a new start.",
  "Saved. Be gentle with yourself.",
  "Entry noted. Rest is allowed.",
  "Saved. Tomorrow's waiting.",
  "Logged for the day.",
  "Entry saved. Breathe.",
  "Saved. No judgment here.",
  "Today noted. Tomorrow's fresh.",
  "Entry logged. Take care.",
  "Saved. Off days happen.",
  "Logged. Rest up for tomorrow.",
  "Entry saved. You're okay.",
  "Saved. Tomorrow's another chance.",
  "Today logged. Rest easy.",
  "Entry noted. Breathe deep.",
  "Saved. Tomorrow's a reset.",
  "Logged. Be kind to yourself.",
  "Entry saved. New day ahead.",
  "Saved. Every day is different.",
  "Today logged. Rest well.",
  "Entry noted. Tomorrow awaits.",
  "Saved. That's perfectly fine.",
  "Logged. Take it slow.",
  "Entry saved. Rest is valid.",
  "Saved. No pressure at all.",
  "Today noted. Fresh start tomorrow.",
  "Entry logged. Be easy.",
  "Saved. Tomorrow's a new page.",
  "Logged for today. Rest.",
  "Entry saved. Breathe easy.",
  "Saved. Tomorrow's a fresh slate.",
  "Today logged. Take care.",
  "Entry noted. Rest up.",
  "Saved. New beginnings tomorrow.",
  "Logged. You're still here.",
  "Entry saved. That's enough.",
  "Saved. Tomorrow's waiting for you.",
  "Today noted. Be gentle.",
  "Entry logged. Rest is part of it.",
  "Saved. Tomorrow is new."
];

// Get random prompt - truly random each time the app opens
export const getDailyPrompt = () => {
  const randomIndex = Math.floor(Math.random() * dailyPrompts.length);
  return dailyPrompts[randomIndex];
};

// Get random completion message
export const getCompletionMessage = (name, hasActivities, hasReflections) => {
  const randomIndex = Math.floor(Math.random() * 50);
  
  if (hasActivities) {
    return activityCompletedMessages[randomIndex].replace('{name}', name);
  } else if (hasReflections) {
    return reflectionOnlyMessages[randomIndex].replace('{name}', name);
  } else {
    return emptyLogMessages[randomIndex];
  }
};
